import React, { useState, useEffect } from "react";
import { Grid, Divider } from "@mui/material";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { IoArrowBackOutline, IoEye, IoEyeOff } from "react-icons/io5";
import CustomInput from "../../Components/CustomInputs/CustomInputs";
import { GreenColorButton } from "../../Components/MaterialButtonStyle/StyleButton";

const ChangePassword = () => {

  const navigate = useNavigate();
  const [passwords, setPasswords] = useState({
    tempPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState({
    tempPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const [NewWeak, setNewWeak] = useState(false);
  const [NewMedium, setNewMedium] = useState(false);
  const [NewStrong, setNewStrong] = useState(false);
  const [ConfirmWeak, setConfirmWeak] = useState(false);
  const [ConfirmMedium, setConfirmMedium] = useState(false);
  const [ConfirmStrong, setConfirmStrong] = useState(false);

  const strongRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&,[\]){}}(^+{#}=_-]{8,}$/;
  const mediumRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d@$!%*?&,[\]({)}^+{#}=_-]{6,}$/;

  const HandleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const RegiterationSubmit = (e) => {
    e.preventDefault();
  };

  const handleToggleVisibility = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleChange = (field, value) => {
    setPasswords((prev) => ({ ...prev, [field]: value }));
  };

  const HandleNewPassword = () => {
    if (passwords.newPassword.trim().length > 0) {
      setNewWeak(true);
    }
    if (mediumRegex.test(passwords.newPassword)) {
      setNewMedium(true);
    }
    if (!mediumRegex.test(passwords.newPassword)) {
      setNewMedium(false);
    }
    if (strongRegex.test(passwords.newPassword)) {
      setNewStrong(true);
    }
    if (!strongRegex.test(passwords.newPassword)) {
      setNewStrong(false);
    }
  };

  const HandleConfirmPassword = () => {
    if (passwords.confirmPassword.trim().length > 0) {
      setConfirmWeak(true);
    }
    if (mediumRegex.test(passwords.confirmPassword)) {
      setConfirmMedium(true);
    }
    if (!mediumRegex.test(passwords.confirmPassword)) {
      setConfirmMedium(false);
    }
    if (strongRegex.test(passwords.confirmPassword)) {
      setConfirmStrong(true);
    }
    if (!strongRegex.test(passwords.confirmPassword)) {
      setConfirmStrong(false);
    }
  };

  const ValidatePassword = (password) => {
    var passwordValidation =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
    return passwordValidation.test(password);
  };
  const UpdateValidation = () => {
    try {
      if(!passwords.tempPassword){
        toast.warn("Temporary Password Can't Be Empty");
        return;
      }
      if (!passwords.newPassword) {
        toast.warn("Password Field Can't Be Empty");
        return;
      }
      if (!ValidatePassword(passwords.newPassword)) {
        toast.warn(
          "Password must be 8 characters long , Must have 1 capital letter atleast, One Number And One Special Character"
        );
        return;
      }
      if (!passwords.confirmPassword) {
        toast.warn("Confirm Password Can't Be Empty");
        return;
      }
      if (!ValidatePassword(passwords.confirmPassword)) {
        toast.warn(
          "Password must be 8 characters long , Must have 1 capital letter atleast, One Number And One Special Character"
        );
        return;
      }
      if (passwords.tempPassword == passwords.newPassword) {
        toast.warn("Temp Password and New Password Can't Be Same");
        return;
      }
      if (passwords.newPassword !== passwords.confirmPassword) {
        toast.warn("Passwords Mismatched");
        return;
      }
      navigate("/");
      window.location.reload();
    } catch (Error) {
      console.log("Error in LoginValidation", Error);
    }
  };

  useEffect(() => {
    HandleNewPassword(passwords.newPassword);
    HandleConfirmPassword(passwords.confirmPassword);
  }, [passwords.newPassword,passwords.confirmPassword]);

  return (
    <Grid container className="loginbgbanner" justifyContent={"space-between"} alignItems={"center"} padding={window.innerWidth > 600 ? 6 : 2}>
      <Grid item container lg={5.8} md={5.8} sm={12} xs={12}>
        <h1 className="poppinsBold Text-Prime-Green  text-left">Welcome to <span className="Text-Prime-White">Police Service Commission</span> Recruitment Portal</h1>
      </Grid>
      <Grid item container lg={4} md={4} sm={12} xs={12} flexDirection={"column"} justifyContent="flex-start" className="bg-white borderRadius12 p-4">
        <h4 role="presentation" className="poppinsMedium Text-Prime-Black  text-left pt-3 pointer w-75" onClick={() => navigate("/")}><IoArrowBackOutline color={"#222222"} size={24} className="mr-2" /> Change Password</h4>
        <Divider className="mt-3" sx={{ border: "1px solid #0FBE7C" }} />
        <p className=" poppinsMedium Text-Prime-Black pt-3 text-left">Please enter the temporary password we sent to your email, then set a new password to secure your account.</p>
        <Grid item lg={12} md={12} sm={12} xs={12} container flexDirection={"column"}>
          <form
            style={{ width: "100%", display: "contents" }}
            className="loginregister"
            onSubmit={RegiterationSubmit}
          >
            <Grid container>
              <p className=" poppinsMedium Text-Prime-Black pt-3">
                Temp Password
              </p>
              <CustomInput
                placeholderColor={"#666666"}
                placeholder="Enter Your Temp Password"
                type={showPassword.tempPassword ? "text" : "password"}
                backgroundColor="#FFFFFF"
                width={"100%"}
                maxLength={50}
                marginTop={"1%"}
                value={passwords.tempPassword}
                padding={"4% 2% 4% 0%"}
                InputProps={showPassword.tempPassword ? (
                  <IoEye
                    className="eyeIcons pointer"
                    onClick={() => handleToggleVisibility("tempPassword")}
                    onMouseDown={HandleMouseDownPassword}
                    color="#222222" size={22}
                  />
                ) : (
                  <IoEyeOff
                    className="eyeIcons pointer"
                    onClick={() => handleToggleVisibility("tempPassword")}
                    onMouseDown={HandleMouseDownPassword}
                    color="#222222" size={22}
                  />
                )}
                onChange={(e) => handleChange("tempPassword", e.target.value)}
              />
            </Grid>
            <Grid container>
              <p className=" poppinsMedium Text-Prime-Black pt-3">New Password</p>
              <CustomInput
                placeholderColor={"#666666"}
                placeholder="Enter Your New Password"
                type={showPassword.newPassword ? "text" : "password"}
                backgroundColor="#FFFFFF"
                width={"100%"}
                maxLength={50}
                marginTop={"1%"}
                padding={"4% 2% 4% 0%"}
                value={passwords.newPassword}
                InputProps={showPassword.newPassword ? (
                  <IoEye
                    className="eyeIcons pointer"
                    onClick={() => handleToggleVisibility("newPassword")}
                    onMouseDown={HandleMouseDownPassword}
                    color="#222222" size={22}
                  />
                ) : (
                  <IoEyeOff
                    className="eyeIcons pointer"
                    onClick={() => handleToggleVisibility("newPassword")}
                    onMouseDown={HandleMouseDownPassword}
                    color="#222222" size={22}
                  />
                )}
                onChange={(e) => handleChange("newPassword", e.target.value)}
              />
            </Grid>
            <Grid
              container
              lg={12}
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              className="mt-2"
            >
              <Grid
                item
                lg={3.5}
                md={3.5}
                sm={3.5}
                xs={3.5}
                height={"30px"}
              >
                <Grid
                  container
                  lg={12}
                  className="p-1 rounded"
                  sx={{
                    backgroundColor: !NewWeak ? "#E0E0E0" : "#E62A4A",
                  }}
                ></Grid>
                {NewWeak && (
                  <p
                    className="text-center mt-1 poppinsRegular fontSize12"
                    style={{ color: "#E62A4A" }}
                  >
                    {" "}
                    Weak
                  </p>
                )}
              </Grid>
              <Grid
                item
                lg={3.5}
                md={3.5}
                sm={3.5}
                xs={3.5}
                height={"30px"}
              >
                <Grid
                  container
                  lg={12}
                  className="p-1 rounded"
                  sx={{
                    backgroundColor: !NewMedium ? "#E0E0E0" : "#E9B229",
                  }}
                ></Grid>
                {NewMedium && (
                  <p
                    className="text-center mt-1 poppinsRegular fontSize12"
                    style={{ color: "#E9B229" }}
                  >
                    {" "}
                    Medium
                  </p>
                )}
              </Grid>
              <Grid
                item
                lg={3.5}
                md={3.5}
                sm={3.5}
                xs={3.5}
                height={"30px"}
              >
                <Grid
                  container
                  lg={12}
                  className="p-1 rounded"
                  sx={{
                    backgroundColor: !NewStrong ? "#E0E0E0" : "#52BD94",
                  }}
                ></Grid>
                {NewStrong && (
                  <p
                    className="text-center mt-1 poppinsRegular fontSize12"
                    style={{ color: "#52BD94" }}
                  >
                    {" "}
                    Strong
                  </p>
                )}
              </Grid>
            </Grid>
            <Grid container>
              <p className=" poppinsMedium Text-Prime-Black pt-3">Confirm Password</p>
              <CustomInput
                placeholderColor={"#666666"}
                placeholder="Enter Your Confirm Password"
                type={showPassword.confirmPassword ? "text" : "password"}
                backgroundColor="#FFFFFF"
                width={"100%"}
                maxLength={50}
                marginTop={"1%"}
                padding={"4% 2% 4% 0%"}
                value={passwords.confirmPassword}
                InputProps={showPassword.confirmPassword ? (
                  <IoEye
                    className="eyeIcons pointer"
                    onClick={() => handleToggleVisibility("confirmPassword")}
                    onMouseDown={HandleMouseDownPassword}
                    color="#222222" size={22}
                  />
                ) : (
                  <IoEyeOff
                    className="eyeIcons pointer"
                    onClick={() => handleToggleVisibility("confirmPassword")}
                    onMouseDown={HandleMouseDownPassword}
                    color="#222222" size={22}
                  />
                )}
                onChange={(e) => handleChange("confirmPassword", e.target.value)}
              />

            </Grid>
            <Grid
              container
              lg={12}
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              className="mt-2"
            >
              <Grid
                item
                lg={3.5}
                md={3.5}
                sm={3.5}
                xs={3.5}
                height={"30px"}
              >
                <Grid
                  container
                  lg={12}
                  className="p-1 rounded"
                  sx={{
                    backgroundColor: !ConfirmWeak ? "#E0E0E0" : "#E62A4A",
                  }}
                ></Grid>
                {ConfirmWeak && (
                  <p
                    className="text-center mt-1 poppinsRegular fontSize12"
                    style={{ color: "#E62A4A" }}
                  >
                    {" "}
                    Weak
                  </p>
                )}
              </Grid>
              <Grid
                item
                lg={3.5}
                md={3.5}
                sm={3.5}
                xs={3.5}
                height={"30px"}
              >
                <Grid
                  container
                  lg={12}
                  className="p-1 rounded"
                  sx={{
                    backgroundColor: !ConfirmMedium ? "#E0E0E0" : "#E9B229",
                  }}
                ></Grid>
                {ConfirmMedium && (
                  <p
                    className="text-center mt-1 poppinsRegular fontSize12"
                    style={{ color: "#E9B229" }}
                  >
                    {" "}
                    Medium
                  </p>
                )}
              </Grid>
              <Grid
                item
                lg={3.5}
                md={3.5}
                sm={3.5}
                xs={3.5}
                height={"30px"}
              >
                <Grid
                  container
                  lg={12}
                  className="p-1 rounded"
                  sx={{
                    backgroundColor: !ConfirmStrong ? "#E0E0E0" : "#52BD94",
                  }}
                ></Grid>
                {ConfirmStrong && (
                  <p
                    className="text-center mt-1 poppinsRegular fontSize12"
                    style={{ color: "#52BD94" }}
                  >
                    {" "}
                    Strong
                  </p>
                )}
              </Grid>
            </Grid>
            {/* <p className=" poppinsMedium text-black fontSize14 pt-3 text-left">For security, your new password should contain:</p>
              <p className=" poppinsRegular text-black fontSize14 pt-1 text-left">1. At least 8 characters</p>
              <p className=" poppinsRegular text-black fontSize14 pt-1 text-left">2. A mix of letters, numbers, and symbols</p>
              <p className=" poppinsRegular text-black fontSize14 pt-1 text-left">If you didn’t receive the temporary password, check your spam folder or bin</p> */}
            <Grid container justifyContent={"center"} className="pt-3">
              <GreenColorButton
                type="submit"
                className="px-5 py-2"
                onClick={() => UpdateValidation()}
              >
                Change Password
              </GreenColorButton>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ChangePassword;